<script setup lang="ts">
import SliderUp from './Sliderup.vue';
import SlideIn from './Slidein.vue';
import { useScreensizeStore } from '../../_02_molecules/components/stores/useScreensizeStore';

defineProps<{ isOpen: boolean }>();

const emit = defineEmits<{(event: 'close'): void;
}>();

const { isMobile } = useScreensizeStore();
</script>

<template>
  <component
    :is="isMobile ? SliderUp : SlideIn"
    :is-opened="isOpen"
    class="slider-offer-proposal"
    @close="emit('close')"
  >
    <template #header>
      <slot name="header" />
    </template>

    <template #body>
      <slot name="body" />
    </template>

    <template #footer>
      <slot name="footer" />
    </template>
  </component>
</template>
